import { Button, Flex, Modal, Stack } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import FieldText from '@/components/shared/form/FieldText';
import FieldTextareaWithEditingMode from '@/components/shared/form/FieldTextareaWithEditingMode';
import Loader from '@/components/ui/Loader';
import MobileBottomDrawer from '@/components/ui/MobileBottomDrawer';
import { NoteQuickCaptureStore } from '@/stores/local/shared/quickThoughts';
import { useDevices } from '@/utils/devices';

import s from './NoteQuickCaptureModal.module.scss';

type NoteQuickCaptureModalProps = {
  store: NoteQuickCaptureStore;
};

const NoteQuickCaptureModal: React.FC<NoteQuickCaptureModalProps> = ({ store: note }) => {
  const { isCompactViewport } = useDevices();

  const buttonMobileText = note.entity === null ? 'Создать заметку' : 'Сохранить заметку';

  const formFields = (
    <>
      <FieldText store={note.form.fieldsMap.caption} label="Заголовок" placeholder="Название заметки" />
      <FieldTextareaWithEditingMode
        store={note.form.fieldsMap.text}
        placeholder="Выделите текст и добавьте комментарий"
        minRows={8}
        autosize
      />
    </>
  );

  if (isCompactViewport) {
    return (
      <MobileBottomDrawer
        opened={note.isOpen}
        onClose={note.close}
        title="Новая заметка"
        contentClassName={s.root__drawer}
        footerClassName={s['root__footer-drawer']}
        actions={
          <Button onClick={note.submit} loading={note.meta.isLoading} disabled={!note.canSubmit}>
            {buttonMobileText}
          </Button>
        }
      >
        {note.isLoading ? (
          <Loader type="dots" fullHeight />
        ) : (
          <div className={s.root__scroll}>
            <Stack gap="md">{formFields}</Stack>
          </div>
        )}
      </MobileBottomDrawer>
    );
  }

  return (
    <Modal
      classNames={{ body: s.root }}
      opened={note.isOpen}
      onClose={note.close}
      title="Новая заметка"
      size="lg"
      centered
      trapFocus={false}
    >
      {note.isLoading ? (
        <Loader type="dots" fullHeight />
      ) : (
        <Stack gap="md">
          {formFields}
          <Flex justify="flex-end" gap="xs">
            <Button variant="default" onClick={note.close}>
              Отмена
            </Button>
            <Button onClick={note.submit} loading={note.meta.isLoading} disabled={!note.canSubmit}>
              Сохранить
            </Button>
          </Flex>
        </Stack>
      )}
    </Modal>
  );
};

export default observer(NoteQuickCaptureModal);
